import avatar from '../../assets/images/avatar.svg'
import {
  AvatarStyles,
  CardTourStyles,
  CardTourWithAvatarStyles,
} from './styles'

const TourUsuariosPermissoes = [
  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <strong> Vamos conhecer o cadastro!</strong>
      </CardTourWithAvatarStyles>
    ),
    target: '#saudacaoUsuariosPermissoes',
    placement: 'center',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Criando novo usuário</p>
        <span>
          Para o cadastro, é importante que todas as informações referentes a
          este colaborador sejam preenchidas, incluindo e-mail e telefone.
        </span>
      </CardTourStyles>
    ),
    target: '#cadastro',
    placement: 'bottom-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Ativo ou inativo</p>
        <span>
          Neste botão você consegue ativar ou inativar o cadastro do usuário.
          <br /> Ele é apresentado também na listagem de usuário.
        </span>
      </CardTourStyles>
    ),
    target: '#ativoInativo',
    placement: 'left-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Permissões de acesso</p>
        <span>
          Em permissões de acesso é possivel configurar o que o usuário poderá
          ver no sistema, selecione apanas as telas que poderá acessar.
        </span>
      </CardTourStyles>
    ),
    target: '#permissoesAcesso',
    placement: 'right-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Permissões de acesso</p>
        <span>
          Caso o usuário deva ter acesso a todas as funções do sistema, dê a ele
          a opção de administrador. <br />
          Selecione também as empresas que esta vinculado.
        </span>
      </CardTourStyles>
    ),
    target: '#permissoesAdm',
    placement: 'right-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Finalizando</p>
        <span>Quando tudo estiver configurado, clique para salvar.</span>
      </CardTourStyles>
    ),
    target: '#salvar',
    placement: 'right-fixed',
  },
  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <strong>Pronto!</strong>
        <br />
        <br />
        <span>Um passo a frente no follow up dos seus clientes!</span>
      </CardTourWithAvatarStyles>
    ),
    target: '#finalizacaoUsuarioPermissoes',
    placement: 'center',
  },
]
export default TourUsuariosPermissoes
